require('isomorphic-fetch');
var querystring = require('querystring');

function timeoutPromise(timeout, err, promise) {
    return new Promise(function (resolve, reject) {
        promise.then(resolve, reject);
        setTimeout(reject.bind(null, err), timeout);
    });
}
/**
 * Lightweight wrapper around `fetch`, adding
 * - querystring support
 * - timeouts
 * - object post bodies
 *
 * https://github.github.io/fetch/
 * @param url
 * @param opts
 * @returns {*}
 */
function fetchWrapper(givenUrl, givenOpts) {
    var url = givenUrl;
    var opts = givenOpts || {};
    if (opts.query) {
        if (typeof opts.query === 'string') {
            url += '?' + opts.query;
        } else {
            url += '?' + querystring.stringify(opts.query);
        }
    }
    if (opts.body && typeof opts.body === 'object') {
        opts.body = JSON.stringify(opts.body);
    }
    var request = fetch(url, opts);
    if (opts.timeout) {
        return timeoutPromise(opts.timeout, new Error('Fetch Request Timeout'), request);
    }
    return request;
}

module.exports = fetchWrapper;



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/fetchier/index.js
// module id = 501
// module chunks = 1